import { booleanAttribute, computed, Directive, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { resolveTypographyClass } from './color';

@Directive({
    selector: '[qpxCell]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxTableCell {
    public readonly context = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxCell',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    public readonly variant = input<'sm' | 'md'>('md');

    protected readonly className = computed(() => {
        let text = '';
        switch (this.variant()) {
            case 'sm':
                text = 'text-table-cell-sm';
                break;
            case 'md':
                text = 'text-table-cell-md';
                break;
        }
        return [
            text,
            resolveTypographyClass(
                this.context(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}
